import React, { useEffect, useState } from "react";
//import "./productstable.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPencil,
    faTrash,
    faEye,
} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../common/Pagination";
import { useDispatch, useSelector } from "react-redux";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";
import ApprovalTwoToneIcon from '@mui/icons-material/ApprovalTwoTone';
import BlockTwoToneIcon from '@mui/icons-material/BlockTwoTone';
import TimerTwoToneIcon from '@mui/icons-material/TimerTwoTone';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, MenuItem, TextField } from "@mui/material";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams, gridClasses, GridColumnHeaderParams } from '@mui/x-data-grid';
import { FinishesService } from "../../service/finishes.service";
import { ThemeProvider, alpha, createTheme, styled } from '@mui/material/styles';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
import { BrandsService } from "../../service/brands.service";



function FinishesTable() {

    const finishesService = new FinishesService();

    const [finishesData, setfinishesData] = useState<any[]>([]);

    //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);

    const navigate = useNavigate();

    const toFinishDetails = (bIndex: string, action: string) => {


        navigate('../finishesdetails', {
            state: {
                finishDetails: finishesData[Number(bIndex) - 1],
                finishesData: finishesData,
                selectedBrand : selectedBrandId,
                brandsData: availableBrands ,
                action: action
            }
        })
    };

    const [selectedBrandId, setSelectedBrandId] = React.useState("select");
    const [availableBrands, setAvailableBrands] = useState([]);
    const [open, setOpen] = React.useState(false);

    /*
    "status": 0,
    "colorId": 1,
    "colorCode": "ZN",
    "colorDesc": "Zink"
    */

    const columns: GridColDef[] = [
        {
            field: 'id', headerName: 'S.no', flex: 1, width: 300
        },
        {
            field: 'colorId', headerName: 'Finish Id', flex: 1
        },

        { field: 'colorCode', headerName: 'Finish Code', flex: 1 },
        { field: 'colorDesc', headerName: 'Finish Description', flex: 1 },
        {
            field: 'status', headerName: 'Status', flex: 1,
            renderCell: (params) => {
                return <div>
                    {params.value == -1 && (<p style={{ color: "blue" }}>Unknown</p>)
                        || params.value == 0 && (<p style={{ color: "red" }}>Deactive</p>)
                        || params.value == 1 && (<p style={{ color: "green" }}>Active</p>)
                    }

                </div>

            }

        },




        {
            field: "action",
            headerName: "Action",
            sortable: false,
            renderCell: (params) => {
                const onClick = (e: { stopPropagation: () => void; }) => {
                    e.stopPropagation(); // don't select this row after clicking

                    const api: GridApi = params.api;
                    const thisRow: Record<string, GridCellParams> = {};

                    api
                        .getAllColumns()
                        .filter((c: { field: string; }) => c.field !== "__check__" && !!c)
                        .forEach(
                            (c: { field: string | number; }) => (thisRow[c.field] = params.value.getValue(params.id, c.field))
                        );

                };

                return <div>
                    <Button onClick={(e) => toFinishDetails(params.value, "edit")} > <IconButton> <EditTwoToneIcon fontSize="small" /></IconButton></Button>

                </div>
            },
            flex: 1
        }

    ];


    let isLoadDataInit = false;
    useEffect(() => {

        if (!isLoadDataInit) {
            isLoadDataInit = true;
            //loadProductSizesData();
            loadBrandsData()
        }

    }, [])

    const brandsService = new BrandsService();
    const loadBrandsData = () => {

        brandsService.brands(1).then(data => {
            const res = data.data;
            //const { unit, sizes } = res.data;
            console.log("^^^^^^^^^^^^^^Unit " + res.length);
            // const unitGroups: any = [];
            /*  for (let index = 0; index < res.length; index++) {
                const unitG = res[index].unit;
                const sizesG = res[index].sizes;
                unitGroups.push({ ...sizesG, unit: unitG, });
              }*/
            console.log("grpp ", res);
            setAvailableBrands(res);

        });

    }

    const loadfinishesData = () => {

        finishesService.fetchFinishes(selectedBrandId).then(data => {
            const res = data.data;
            //console.log('finishesData', res)
            let cnt1 = 0;
            const peopleWithImages = res.map((person: any, index: any) => {
                cnt1 = cnt1 + 1;
                return {
                    ...person,
                    id: cnt1,
                    action: person.colorId,
                };

            });
            setfinishesData(peopleWithImages)


        });

    }

    useEffect(() => {

        console.log("eeee " + selectedBrandId)

        if (selectedBrandId == "select") {
            return;
        }
        loadfinishesData();



    }, [selectedBrandId])

    const CustomFontTheme = createTheme({
        typography: {
            fontSize: 14
        }
    });


    return (
        <div className="App border card">
            <div className="row border-bottom m-0 col-md-12 mt-3">
                <div className=" mb-3 col-2   text-left ">
                    <ThemeProvider theme={CustomFontTheme}>
                        <TextField select size="small" label="Brand Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                            className="form-control" name='brandId' defaultValue="select" value={selectedBrandId}
                            onChange={(e: any) => {
                                setSelectedBrandId(e.target.value);

                            }}
                        >
                            <MenuItem style={{ fontSize: "small" }} disabled value="select" key="select">Select</MenuItem>
                            {availableBrands.map((_el: any) => <MenuItem style={{ fontSize: "small" }} key={_el.brandId} value={_el.brandId}> {_el.brandName}</MenuItem>)}
                        </TextField>
                    </ThemeProvider>
                </div>
                <div className="col-md-8"></div>
                <div className="pull-r text-right col-md-2">
                    <Button size="small" style={{ color: "green" }} className="form-control text-right" onClick={() => 
                        
                        {
                            navigate('../finishesdetails',{state:{
                           
                              brandsData: availableBrands ,
                              selectedBrand : selectedBrandId
                            }})
            
                           }
                        
                        } variant="text" startIcon={<AddCircleOutlineTwoToneIcon />}>
                        Add New
                    </Button>
                </div>
            </div>





            <div style={{ width: '100%' }}>
                <DataGrid

                    // table customization start
                    sx={{
                        '& .MuiDataGrid-columnHeaderTitle': {
                            whiteSpace: "break-spaces", lineHeight: 1, fontSize: "13px", fontWeight: "bold",
                        },
                        '& .MuiDataGrid-columnHeader': {
                            backgroundColor: "#D0D0D0"
                        },
                        '& .Mui-odd': {
                            textOverflow: "inherit", fontSize: "12px", textAlign: "left"
                        },

                        '& .Mui-even': {
                            backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"

                        },

                        '& .Mui-cellown': {
                            paddingTop: 0, paddingBottom: 0

                        },

                    }}

                    getCellClassName={(params) => 'Mui-cellown'}
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
                    autoHeight={true}
                    getRowHeight={() => 'auto'}

                    // table customization


                    rows={finishesData}
                    columns={columns}

                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                        },
                    }}
                    pageSizeOptions={[10, 25, 50]}

                />
            </div>

        </div>

    );
}


export default FinishesTable;
